var _defs, _circle, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppWebmeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8fcf00;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18,
    cy: 18,
    r: 18
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.29,
    y: 11.01,
    width: 20.44,
    height: 5.86,
    rx: 2.93,
    ry: 2.93
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.75,16.88l2.52,2.52c.19.19.52.06.52-.22v-2.3h-3.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.51,20.22c.93,0,1.69.76,1.69,1.69s-.76,1.69-1.69,1.69h-11.55c-.93,0-1.69-.76-1.69-1.69s.76-1.69,1.69-1.69h11.55m0-1h-11.55c-1.49,0-2.69,1.2-2.69,2.69s1.2,2.69,2.69,2.69h11.55c1.49,0,2.69-1.2,2.69-2.69s-1.2-2.69-2.69-2.69h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.22,24.6l-2.09,2.09c-.16.16-.43.05-.43-.18v-1.91s2.52,0,2.52,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppWebmeeting);
export default __webpack_public_path__ + "static/media/app_webmeeting.620981ba6f494150e18c384bdd577b2b.svg";
export { ForwardRef as ReactComponent };